// fork overlay: fork-owned helper (mirrors en/deep-merge.js)
// Recursive deep-merge: plain objects merged key-wise; arrays replaced wholesale; scalars overwrite.
// Prototype-safe: iterates only own-enumerable keys via Object.keys(source).
//
// IMPORTANT: This function mutates target in place (and returns it for chaining).
// Do NOT pass a frozen or const-shared object as `target`.
export default function deepMerge(target, source) {
  for (const key of Object.keys(source)) {
    if (key === '__proto__' || key === 'constructor') continue;
    const s = source[key];
    const t = target[key];
    if (s && typeof s === 'object' && !Array.isArray(s)
        && t && typeof t === 'object' && !Array.isArray(t)) {
      deepMerge(t, s);
    } else {
      target[key] = s;
    }
  }
  return target;
}
